module.exports = __webpack_public_path__ + "img/Success.8e86cc87.svg";